import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Helmet from 'react-helmet'
import { useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

// local imports
import { actionCreators } from '../state/state-index'
import RateService from 'service/RateService'
import { INotRatedReservations } from 'types/RateType'
import Private from './Private'
import Plan from '../components/home/Plan'
import RatingDialog from 'components/evaluations/RatingDialog'
import AuthUtil from 'utils/AuthUtil'
import { IEmployeeSummary } from 'types/Employee'

const employee = AuthUtil.getEmployeeSummary() as IEmployeeSummary

const Home = () => {
  const PILOT_FIRMS = !!process.env.REACT_APP_PILOT_FIRMS
    ? process.env.REACT_APP_PILOT_FIRMS.split(',').map((str) => Number(str))
    : []

  const IS_PILOT_USER = !!PILOT_FIRMS?.length ? PILOT_FIRMS.includes(employee?.firmId || 0) : true

  const { t } = useTranslation()
  const location = useLocation()
  const query = new URLSearchParams(location.search)
  const dispatch = useDispatch()
  const { cleanDaysState } = bindActionCreators(actionCreators, dispatch)

  /* Pending Reservations Rate */
  const [reservationInfo, setReservationInfo] = useState<INotRatedReservations>()
  const [rateDisplay, setRateDisplay] = useState(false)
  const getPendingNotRatedRes = () => {
    RateService.getNotRatedReservationPopup()
      .then((response) => {
        if (!!response.data.reservationId) {
          setRateDisplay(true)
          setReservationInfo(response?.data)
        }
      })
      .catch((e) => console.log(e))
  }

  useEffect(() => {
    if (IS_PILOT_USER && AuthUtil.isAdmin(employee?.authList)) getPendingNotRatedRes()
  }, [IS_PILOT_USER])
  /* Pending Reservations Rate */

  useEffect(() => {
    cleanDaysState(true)
  })

  const hasNotifications = !!query.get('notification')

  return (
    <Private>
      <Helmet>
        <title>Koç Office Free - {t('nav-menu-items.homepage')}</title>
        <meta
          name="description"
          content="Office Free ile ister şirketinden, ister Koç Topluluğu ortak ofislerinden çalışma planı gerçekleştirebilir, istersen de uzaktan çalışma bildirimi yapabilirsin."
        />
      </Helmet>

      <Plan notification={hasNotifications} />

      {rateDisplay && !!reservationInfo && (
        <RatingDialog
          getReservationList={() => {}}
          selectedRes={reservationInfo}
          visible={rateDisplay}
          closeDialog={() => setRateDisplay(false)}
        />
      )}
    </Private>
  )
}

export default Home
